export function initializeYearDropdown() {
    const yearDropdown = document.getElementById("input_1_12_3");
    if (!yearDropdown) return;

    const previousValue = yearDropdown.value;

    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 4;
    
    yearDropdown.innerHTML = "";
    
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.text = "Year";
    yearDropdown.appendChild(defaultOption);
    
    for (let year = currentYear; year <= maxYear; year++) {
        const option = document.createElement("option");
        option.value = year;
        option.text = year;
        yearDropdown.appendChild(option);
    }

    // Restore the previously selected value if it's still valid
    if (previousValue) {
        yearDropdown.value = previousValue;
    }
}